import React from "react";
import Masonry from "react-masonry-component";
import "flatpickr/dist/themes/light.css";
import { Arabic } from "flatpickr/dist/l10n/ar.js";
import Flatpickr from "react-flatpickr";
import { addQueryString, qsToObject, isRTL, masonryOptions } from "./utils";
import { useInView } from "react-intersection-observer";

const isLoggedIn =
  document.querySelector("#UserLoginStatus") &&
  document.querySelector("#UserLoginStatus").value === "False";


const WhatsOnListing = ({
  articleListing,
  dealsListing,
  whatsonListing,
  pressReleaseListing,
}) => {
  const [ref, inView] = useInView({
    rootMargin: "0px 0px 0px 0px",
    triggerOnce: true,
  });
  const [response, setresponse] = React.useState();
  const [hits, sethits] = React.useState();
  const [date, setdate] = React.useState();
  const [hideLoadMore, sethideLoadMore] = React.useState(false);
  const [showLoader, setshowLoader] = React.useState(false);
  const [updateFilters, setupdateFilters] = React.useState(false);
  const [showSearchError, setshowSearchError] = React.useState(false);
  const queriesObject = qsToObject(window.location.search);
  let searchedText = queriesObject.searchTerm;
  let isFindYour30 = false;

  let config = window.whatsonConfig;
  if (articleListing) {
    isFindYour30 = true;
    config = window.findYour30Config;
  } else if (dealsListing) {
    config = window.DealAndOffersConfig;
  } else if (pressReleaseListing) {
    config = window.pressCenterConfig;
  }

  React.useEffect(() => {
    console.log(inView);
  }, [inView]);

  React.useEffect(() => {
    if (inView) {
      let searchTerm = queriesObject.searchTerm;
      let filteredDate = queriesObject.filterDate;
      if (searchTerm === undefined) {
        searchTerm = "";
      }
      if (filteredDate === undefined) {
        filteredDate = "";
      } else {
        setdate(decodeURIComponent(filteredDate));
      }
      sethideLoadMore(false);

      setshowLoader(true);
      //console.log(`${config.apiUrl}?parentPageId=2529&pageNumber=1&pagesize=100&eventTypeId=3529&filterDate=&searchTerm=&culture=en-US`)
      let apiUrl = `${config.apiUrl}?parentPageId=${
        config.parentPageId
      }&pageNumber=${config.pageNumber}&pagesize=${
        config.pagesize
      }&eventTypeId=${
        queriesObject.eventTypeId || config.eventTypeId
      }&filterDate=${filteredDate}&searchTerm=${searchTerm}&culture=${
        config.culture
      }`;
      if (articleListing) {
        apiUrl = `${config.apiUrl}?parentPageId=${
          config.parentPageId
        }&pageNumber=${config.pageNumber}&pagesize=${
          config.pagesize
        }&articleTypeId=${
          queriesObject.articleTypeId || config.articleTypeId
        }&articleSubTypeId=${
          queriesObject.articleSubTypeId || config.articleSubTypeId
        }&filterDate=${filteredDate}&searchTerm=${searchTerm}&culture=${
          config.culture
        }`;
      } else if (dealsListing) {
        apiUrl = `${config.apiUrl}?parentPageId=${
          config.parentPageId
        }&pageNumber=${config.pageNumber}&pagesize=${
          config.pagesize
        }&offerTypeId=${
          queriesObject.offerTypeId || config.offerTypeId
        }&searchTerm=${searchTerm}&culture=${config.culture}&CategoryFolder=${
          config.CategoryFolder
        }`;
      } else if (pressReleaseListing) {
        apiUrl = `${config.apiUrl}?parentPageId=${
          config.parentPageId
        }&pageNumber=${config.pageNumber}&pagesize=${
          config.pagesize
        }&offerTypeId=${
          queriesObject.offerTypeId || config.offerTypeId
        }&searchTerm=${searchTerm}&culture=${config.culture}`;
      }
      fetch(apiUrl)
        .then((result) => result.json())
        .then(
          (result) => {
            if (isFindYour30) {
              let qs = qsToObject(window.location.search);
              if (
                !(
                  qs.hasOwnProperty("articleSubTypeId") &&
                  qs.hasOwnProperty("articleTypeId")
                )
              ) {
                if (result && result.filters && result.filters.length) {
                  addQueryString("articleSubTypeId", "0");
                  setFilters(result.filters[0].id, `articleTypeId`);
                }
              }
            }

            setresponse(result);

            sethits(result && result.pagination && result.pagination.Results);

            // setupdateFilters(false)
            if (
              result &&
              result.pagination &&
              result.pagination.PageCount === 1
            ) {
              sethideLoadMore(true);
            }
            setshowLoader(false);
          },
          (error) => {
            setshowLoader(false);
            console.error(error);
          }
        );
    }
  }, [inView, updateFilters]);
  const loadMore = (e) => {
    e.preventDefault();

    const pageCount =
      response && response.pagination && response.pagination.PageCount;
    const NextPage =
      response && response.pagination && response.pagination.NextPage;
    let searchTerm = queriesObject.searchTerm;
    let filteredDate = queriesObject.filterDate;
    if (pageCount <= NextPage) {
      sethideLoadMore(true);
    }
    if (searchTerm === undefined) {
      searchTerm = "";
    }
    if (filteredDate === undefined) {
      filteredDate = "";
    }
    setshowLoader(true);

    let apiUrl = `${config.apiUrl}?parentPageId=${
      config.parentPageId
    }&pageNumber=${NextPage}&pagesize=${config.pagesize}&eventTypeId=${
      queriesObject.eventTypeId || config.eventTypeId
    }&filterDate=${filteredDate}&searchTerm=${searchTerm}&culture=${
      config.culture
    }`;
    if (articleListing) {
      apiUrl = `${config.apiUrl}?parentPageId=${
        config.parentPageId
      }&pageNumber=${NextPage}&pagesize=${config.pagesize}&articleTypeId=${
        queriesObject.articleTypeId || config.articleTypeId
      }&articleSubTypeId=${
        queriesObject.articleSubTypeId || config.articleSubTypeId
      }&filterDate=${filteredDate}&searchTerm=${searchTerm}&culture=${
        config.culture
      }`;
    } else if (dealsListing) {
      apiUrl = `${config.apiUrl}?parentPageId=${
        config.parentPageId
      }&pageNumber=${NextPage}&pagesize=${config.pagesize}&offerTypeId=${
        queriesObject.offerTypeId || config.offerTypeId
      }&searchTerm=${searchTerm}&culture=${config.culture}&CategoryFolder=${
        config.CategoryFolder
      }`;
    } else if (pressReleaseListing) {
      apiUrl = `${config.apiUrl}?parentPageId=${
        config.parentPageId
      }&pageNumber=${NextPage}&pagesize=${config.pagesize}&offerTypeId=${
        queriesObject.offerTypeId || config.offerTypeId
      }&searchTerm=${searchTerm}&culture=${config.culture}`;
    }
    fetch(apiUrl)
      .then((res) => res.json())
      .then(
        (result) => {
          setresponse(result);

          if (hits) {
            sethits(
              hits.concat(
                result && result.pagination && result.pagination.Results
              )
            );
          } else {
            sethits(result && result.pagination && result.pagination.Results);
          }

          setshowLoader(false);
        },

        (error) => {
          setshowLoader(false);
          console.error(error);
        }
      );
  };
  const setFilters = (value, filterName) => {
    addQueryString(filterName, value);
    setupdateFilters(!updateFilters);
  };

  return (
    <div ref={ref}>
      {showLoader && <div className="ajax-loader"></div>}

      <div className="explore-whats-on__search">
        <div className="search-filter-box">
          <div className="input-group search-filter-box__input">
            <div className="input-group-prepend">
              <span className="icon icon-search"></span>
            </div>
            <input
              type="text"
              className="form-control"
              onChange={(e) => {
                searchedText = e.target.value;
              }}
              onKeyPress={(e) => {
                if (searchedText !== undefined) {
                  if (e.key === "Enter") {
                    if (searchedText === "") {
                      setshowSearchError(true);
                    } else {
                      setshowSearchError(false);
                    }
                    setFilters(searchedText, "searchTerm");
                  }
                } else {
                  if (e.key === "Enter") {
                    console.log("show error");
                    setshowSearchError(true);
                  }
                }
              }}
              defaultValue={searchedText && searchedText.replace("+", " ")}
              id="inlineFormInputGroup"
              placeholder={
                response &&
                response.dictionary_items &&
                response.dictionary_items.Searchbox
              }
            />
            <span
              className="input-group-btn search-filter-box__btn"
              onClick={() => {
                if (searchedText !== undefined) {
                  if (searchedText === "") {
                    setshowSearchError(true);
                  } else {
                    setshowSearchError(false);
                  }

                  setFilters(searchedText, "searchTerm");
                } else {
                  setshowSearchError(true);
                  console.log("show error");
                }
              }}
            ></span>
          </div>
          {showSearchError && (
            <span className="search-filter-box__error">
              {response &&
                response.dictionary_items &&
                response.dictionary_items.VEMSearchTextField}
            </span>
          )}
        </div>

        {whatsonListing && (
          <div className="explore-whats-on__col">
            <div className="custom-link custom-link__date-filter">
              <span className="icon icon-date custom-link__icon"></span>
              <div className="custom-link__label">
                <div className="custom-link__select">
                  <select name="" id="">
                    <option value="Any">
                      {response &&
                        response.dictionary_items &&
                        response.dictionary_items.FilterDate}
                    </option>
                  </select>
                </div>
                <div className="custom-link__value">
                  {date ||
                    (response &&
                      response.dictionary_items &&
                      response.dictionary_items.FilterDateAny)}
                </div>
                <Flatpickr
                  options={{
                    disableMobile: "true",
                    locale: !isRTL ? "en" : Arabic,
                    //  mode : 'range'
                    //  dateFormat:'m/d/Y',
                    //     defaultDate:'11/31/2020'
                  }}
                  // value={date}
                  onChange={(date) => {
                    const getDate = new Date(date);

                    setFilters(
                      getDate.getMonth() +
                        1 +
                        "%2F" +
                        getDate.getDate() +
                        "%2F" +
                        getDate.getFullYear(),
                      "filterDate"
                    );
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {articleListing && (
        <>
          <div className="explore-whats-on__categories">
            <ul className="explore-whats-on__category-items">
              {response &&
                response.filters &&
                response.filters.map((item, index) => {
                  return (
                    <li
                      key={index}
                      onClick={(e) => {
                        if (articleListing) {
                          addQueryString("articleSubTypeId", "0");
                        }
                        setFilters(
                          e.target.getAttribute("data-id"),
                          `${articleListing ? "articleTypeId" : ""}${
                            dealsListing ? "offerTypeId" : ""
                          }${whatsonListing ? "eventTypeId" : ""}`
                        );
                      }}
                      className={`explore-whats-on__category-item 
                    ${
                      item &&
                      item.id ==
                        (queriesObject.articleTypeId || config.articleTypeId)
                        ? "active"
                        : ""
                    } 
                  
                    `}
                    >
                      <span
                        data-id={item && item.id}
                        className="btn btn-expended-full-color"
                      >
                        {item && item.filter_title}
                      </span>
                    </li>
                  );
                })}
            </ul>
          </div>

          <div className="explore-whats-on__filters">
            <ul className="explore-whats-on__items">
              {response &&
                response.filters &&
                response.filters.map((item, index) => {
                  return (
                    item &&
                    item.sub_filters &&
                    item.sub_filters.map((filter, index) => {
                      if (
                        item &&
                        item.id ==
                          (queriesObject.articleTypeId || config.articleTypeId)
                      ) {
                        return (
                          <li
                            key={index}
                            className={`explore-whats-on__item ${
                              filter &&
                              filter.id ==
                                (queriesObject.articleSubTypeId ||
                                  config.articleSubTypeId)
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              setFilters(
                                e.target.getAttribute("data-id"),
                                "articleSubTypeId"
                              );
                            }}
                          >
                            <span data-id={filter && filter.id}>
                              {filter && filter.filter_title}
                            </span>
                          </li>
                        );
                      }
                    })
                  );
                })}
            </ul>
          </div>
        </>
      )}
      {!articleListing && (
        <div className="explore-whats-on__filters">
          <ul className="explore-whats-on__items">
            {response &&
              response.filters &&
              response.filters.map((filter, index) => {
                return (
                  <li
                    key={index}
                    className={`explore-whats-on__item 
                ${
                  filter &&
                  filter.id == (queriesObject.offerTypeId || config.offerTypeId)
                    ? "active"
                    : ""
                }
                ${
                  filter &&
                  filter.id == (queriesObject.eventTypeId || config.eventTypeId)
                    ? "active"
                    : ""
                }
                `}
                    onClick={(e) => {
                      if (articleListing) {
                        addQueryString("articleSubTypeId", "0");
                      }
                      setFilters(
                        e.target.getAttribute("data-id"),
                        `${articleListing ? "articleTypeId" : ""}${
                          dealsListing ? "offerTypeId" : ""
                        }${whatsonListing ? "eventTypeId" : ""}`
                      );
                    }}
                  >
                    <span data-id={filter && filter.id}>
                      {filter && filter.filter_title}
                    </span>
                  </li>
                );
              })}
          </ul>
        </div>
      )}

      {dealsListing || pressReleaseListing ? (
        <div className="deals-offers">
          <div className="container">
            <div className="row">
              {hits &&
                hits.map((item, index) => {
                  return (
                    <div key={index} className="col-4">
                      <div className="deals-offers__wrap">
                        <div
                          className={`deals-offers__item ${
                            dealsListing && isLoggedIn
                              ? "deals-offers__item--locked"
                              : ""
                          } `}
                        >
                          <div className="deals-offers__image">
                            <img
                              src={item && item.image}
                              alt={item && item.title}
                            />
                          </div>
                          {isLoggedIn && (dealsListing || pressReleaseListing) && (
                            <div className="deals-offers__content">
                              <h4 className="deals-offers__content-heading">
                              {item && item.title}
                              </h4>
                              <div className="deals-offers__content-btns">
                                <a
                                  href={item && item.url}
                                  className="btn btn-rounded btn-rounded-white-filled"
                                >
                                  {response &&
                                    response.dictionary_items &&
                                    response.dictionary_items.RegisterNow}
                                </a>
                              </div>
                            </div>
                          )}
                        </div>
                        {!isLoggedIn && (dealsListing || pressReleaseListing) && (
                          <div className="deals-offers__info">
                            <div className="deals-offers__info-category">
                              {(item && item.date) ||
                                (item.categories &&
                                  item.categories.map((category, index) => {
                                    if (item.categories.length === index + 1) {
                                      return `${category.Title} `;
                                    } else {
                                      return `${category.Title} | `;
                                    }
                                  }))}
                            </div>
                            <h4 className="deals-offers__info-title press ">
                              {item && item.title}{" "}
                            </h4>
                            {item && item.summary && (
                              <p className="general__para">
                                {item && item.summary}
                              </p>
                            )}

                            <a
                              href={item && item.url}
                              className="btn btn-expended-full-color"
                            >
                              {" "}
                              {(response &&
                                response.dictionary_items &&
                                response.dictionary_items.SeeOffers) ||
                                response.dictionary_items.PressReadMore}
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      ) : (
        <div className="explore-whats-on__grid">
          <div className="masonry__grid">
            <Masonry
              className={"grid"} // default ''
              elementType={"div"} // default 'div'
              options={masonryOptions} // default {}
              disableImagesLoaded={false} // default false
              updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
              // imagesLoadedOptions={imagesLoadedOptions} // default {}
            >
              {hits &&
                hits.map((item, index) => {
                  return (
                    <div
                      key={index}
                      data-end-date={item && item.event_end_date}
                      data-start-date={item && item.event_start_date}
                      className={`grid-item  
                ${index === 0 ? "grid-item--large" : ""}
                ${index === 2 ? "grid-item--large" : ""}
                ${index === 3 ? "grid-item--large" : ""}
                
                `}
                    >
                      <div className="masonry__item">
                        <div className="masonry__category">
                          {isFindYour30
                            ? item && item.article_subtype_text
                            : (item && item.event_type_text) ||
                              item.article_type_text}
                        </div>
                        <div className="masonry__image">
                          <img
                            src={
                              (item && item.image) ||
                              "/Common/images/placeholder.jpg"
                            }
                            alt="image"
                          />
                        </div>
                        <div className="masonry__content">
                          <h6 className="masonry__sub-heading">
                            {isFindYour30
                              ? item && item.category_title
                              : (item && item.tag) || item.location}
                          </h6>
                          <h4 className="masonry__heading">
                            {item && item.title}
                          </h4>
                          <div className="masonry__extras">
                            <p className="masonry__para">
                              {(item && item.summary) || item.description}{" "}
                            </p>
                            <div className="masonry__btns">
                              <a
                                href={item && item.url}
                                className="btn btn-rounded btn-rounded-white masonry__btn"
                              >
                                {(response &&
                                  response.dictionary_items &&
                                  response.dictionary_items.SeeEvents) ||
                                  response.dictionary_items.SeeArticle}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </Masonry>
          </div>
        </div>
      )}
      {hits && hits.length === 0 && (
        <div className="no-results">
          <div className="container">
            <div className="row">
              <div className="col-10 offset-md-1">
                <h2>
                  {(response &&
                    response.dictionary_items &&
                    response.dictionary_items.EventResultNotFound) ||
                    response.dictionary_items.NoArticleFound}
                </h2>
              </div>
            </div>
          </div>
        </div>
      )}
      {!hideLoadMore && hits && hits.length !== 0 && (
        <div className="explore-whats-on__buttons">
          <span
            onClick={(e) => {
              loadMore(e);
            }}
            className="btn btn-expended-full-color"
          >
            {response &&
              response.dictionary_items &&
              response.dictionary_items.LoadMore}
          </span>
        </div>
      )}
    </div>
  );
};

export default WhatsOnListing;
